export default "__VITE_ASSET__DXDlkLyg__"